import Grid from "../Grid/grid";
import Title from "../title";
import Process from "../process";
import mobileAppDevelopmentProcess from "./data/mad-process-data";
import contentImage from "../../Assets/image/services-pages-images/mobile-app-developmet/mad-content.webp"

function MadProcess() {
  return (
    <section className="w-full min-h-screen h-full relative flex flex-col overflow-hidden p-2 lg:p-16">
      <Grid size={100} direction="top-left" />
      <div className="z-10 flex justify-start items-start mb-12 w-full">
        <Title title="our process" />
      </div>
      <Process
        data={mobileAppDevelopmentProcess}
        img={contentImage}
        title="Mobile App Development"
        description="Building Scalable & High-Performance Mobile Apps – Custom Solutions to Drive Your Success."
      />
    </section>
  );
}

export default MadProcess;
